import FormLegacyHelper from "@Scripts/Infrastructure/FormLegacyHelper";
import Vue from "vue";
import Component from "vue-class-component";

@Component({ name: "DealerSearchBox" })
export default class DealerSearchBox extends Vue {
    public validationErrors: any[] = [];
    public productCategories: any[] = [];
    public provinces: any[] = [];
    public locations: any[] = [];
    public productCategoryName: string = null;
    public province: string = null;
    public location: string = null;
    public dealer: any = null;

    get routes() {
        return (<any>window).App.routes;
    }

    public created() {
        this.$store.dispatch("catalogueStore/getProductCategories").then((response) => {
            this.productCategories = response.data;
        });

        this.$store.dispatch("salesNetStore/getProvinces").then((response) => {
            this.provinces = response.data;
        });
    }

    public async getLocations() {
        if (this.province) {
            let response = await this.$store.dispatch("salesNetStore/getLocations", {
                provinceCode: this.province
            });

            if (response.data) {
                this.locations = response.data;

                if (response.data.length === 1) {
                    this.location = response.data[0].value;
                }
            }
        } else {
            this.locations = null;
        }
    }

    public async getDealer() {
        this.validationErrors = [];
        FormLegacyHelper.resetValidation();
        this.dealer = null;

        try {
            let response = await this.$store.dispatch("salesNetStore/getDealer", {
                productCategoryName: this.productCategoryName,
                province: this.province,
                location: this.location
            });

            if (response.data) {
                this.dealer = response.data;
            } else {
                this.dealer = null;
            }
        } catch (error) {
            FormLegacyHelper.resetValidation();

            if (error.response) {
                if (error.response.status === 400) {
                    let validationState = error.response.data;
                    FormLegacyHelper.setValidation(validationState);

                    for (var propertyName in error.response.data) {
                        if (error.response.data.hasOwnProperty(propertyName)) {
                            for (let message of error.response.data[propertyName]) {
                                this.validationErrors.push({ message: message });
                            }
                        }
                    }
                }
            }
        }
    }
};